import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=4c6a47be&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6a47be')) {
      api.createRecord('4c6a47be', component.options)
    } else {
      api.reload('4c6a47be', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=4c6a47be&", function () {
      api.rerender('4c6a47be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j5GmkMgYfn87/JS/offershelp.vue"
export default component.exports